<template>
  <div>
    <v-dialog
      v-if="request"
      :value="value"
      @input="$emit('input', $event)"
      width="75vw"
      max-width="1200px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="headline">案件予算の削除</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-layout column mb-4>
              <v-flex class="label">広告主名</v-flex>
              <v-flex class="value">{{ request.advertiserName }}</v-flex>
            </v-layout>
            <v-layout column mb-4>
              <v-flex class="label">案件名</v-flex>
              <v-flex class="value">{{ request.insertionOrderName }}</v-flex>
            </v-layout>
            <v-layout column mb-4>
              <v-flex class="label">期間・予算</v-flex>
              <v-flex class="value">
                <v-layout>
                  <v-flex sm6>
                    <AppPeriod
                      :start="request.startTime"
                      :end="request.endTime"
                    />
                  </v-flex>
                  <v-flex sm2 class="text-xs-right">
                    <AppCurrency :value="request.budget" /><br />
                    <NetBudget :value="request.netBudget" />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn @click="deleteBudget" color="primary">削除</v-btn>
          <v-btn @click="close">キャンセル</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DeleteErrorModal
      v-model="deleteErrorModalVisible"
      :campaign-list="filteredCampaignList"
    />
  </div>
</template>

<script>
import NetBudget from './NetBudget.vue'
import DeleteErrorModal from './DeleteErrorModal.vue'
import { actions } from '@/vuex/modules/admin/request/budget/constants'
import {
  actions as snackbarActions,
  snackbarType,
} from '@/vuex/modules/ui/snackbar/constants'
import { CampaignBudgetRepository } from '@/models/CampaignOperation/CampaignBudgetRepository'
import CampaignApi from '@/api/Campaign'

export default {
  name: 'RejectModal',
  components: { NetBudget, DeleteErrorModal },
  props: {
    value: Boolean,
    request: Object,
  },
  data() {
    return {
      deleteErrorModalVisible: false,
      campaignList: [],
      campaignBudgets: [],
      filteredCampaignList: [],
    }
  },
  methods: {
    async deleteBudget() {
      try {
        await this.request.approve()
        this.$store.dispatch(snackbarActions.SHOW_SNACKBAR, {
          type: snackbarType.SUCCESS,
          message: '削除しました',
        })
        this.$store.dispatch(actions.SEARCH)
        this.close()
      } catch (e) {
        this.close()
        this.filterCampaigns()
        this.deleteErrorModalVisible = true
      }
    },
    async fetchCampaignList() {
      const ret = await CampaignApi.search({
        advertiserId: this.request.advertiserId,
        insertionOrder: {
          ids: [this.request.insertionOrderId],
        },
        pageNo: undefined,
        pageSize: undefined,
      })
      this.campaignList = ret.items
    },
    async getCampaignBudgets(campaignList) {
      this.campaignBudgets = Promise.all(
        campaignList.map(async campaign => {
          return await CampaignBudgetRepository.getByCampaignId(campaign.id)
        }),
      )
    },
    async filterCampaigns() {
      await this.fetchCampaignList()
      if (this.campaignList === undefined) {
        return
      }
      await this.getCampaignBudgets(this.campaignList)
      if (this.campaignBudgets === undefined) {
        return
      }
      this.campaignBudgets.then(value => {
        const filteredCampaignBudgetIds = value
          .filter(campaign => {
            return campaign.item.campaignBudgets.some(
              budget =>
                budget.insertionOrderBudgetId ===
                this.request.insertionOrderBudgetId,
            )
          })
          .map(campaign => campaign.item.campaignId)
        this.filteredCampaignList = this.campaignList.filter(campaign => {
          return filteredCampaignBudgetIds.includes(campaign.id)
        })
      })
    },
    close() {
      this.$emit('input', false)
    },
  },
}
</script>

<style scoped lang="scss">
.label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}

.value {
  font-size: 16px;
}
</style>
